import { ProcessedInterval } from "../../../types/Manager";

const DAY_ORDER: Record<string, number> = {
  friday: 0,
  saturday: 1,
  sunday: 2,
  monday: 3,
  tuesday: 4,
  wednesday: 5,
  thursday: 6,
};

const isActiveInterval = (interval: ProcessedInterval | null | undefined) =>
  Boolean(
    interval?.start_time &&
      interval?.end_time &&
      (interval.end_time !== interval.start_time ||
        interval.end_day !== interval.start_day)
  );

/** Normalize interval arrays so 7-element form arrays compare equal to variable-length Redux arrays. */
export const normalizeIntervals = (arr: ProcessedInterval[] | null | undefined) =>
  (arr || [])
    .filter(Boolean)
    .filter(isActiveInterval)
    .map(({ start_day, end_day, start_time, end_time }) => ({
      start_day,
      end_day,
      start_time,
      end_time,
    }))
    .sort(
      (a, b) =>
        (DAY_ORDER[a.start_day] ?? 0) - (DAY_ORDER[b.start_day] ?? 0)
    );
